import { gql } from '@apollo/client';
import { insuranceFragment } from 'store/fragments';

export default gql`
  mutation CancelInsuranceProduct($bookingReference: String!, $fee: Float!, $itemRef: String!, $skipConfirmation: Boolean) {
    cancelInsuranceProduct(bookingReference: $bookingReference, itemRef: $itemRef, fee: $fee, skipConfirmation: $skipConfirmation) {
      reference
      paymentsRefundBalance
      insurances {
        ...CompleteInsurance
      }
    }
  }

  ${insuranceFragment}
`;
